import { toast, ToasterProps } from 'sonner';

interface ToastParams {
  message: string;
  options?: ToasterProps;
}

export const successToast = ({ message, options }: ToastParams) => {
  toast.success(message, {
    duration: 3000,
    position: 'top-center',
    ...options,
  });
};

export const errorToast = ({ message, options }: ToastParams) => {
  toast.error(message, {
    duration: 3000,
    position: 'top-center',
    ...options,
  });
};

export const warningToast = ({ message, options }: ToastParams) => {
  toast.warning(message, {
    duration: 3000,
    position: 'top-center',
    ...options,
  });
};

export const infoToast = ({ message, options }: ToastParams) => {
  toast.info(message, {
    duration: 3000,
    position: 'top-center',
    ...options,
  });
};

export const customToast = ({ message, options }: ToastParams) => {
  toast(message, {
    duration: 3000,
    position: 'top-center',
    ...options,
  });
};
